<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="prefix"
                  label="Prefix"
                  v-model="systemSerialize.prefix"
                  type="text"
                  :rules="[
                            () => !!systemSerialize.prefix || 'Prefix is required',
                          ]"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="systemSerialize.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="systemSerialize.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="systemSerialize.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="systemSerialize.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="systemSerialize.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="systemSerialize.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :disabled="systemSerialize.id ? true : false"
                  :items="typeList"
                  v-model="systemSerialize.type"
                  label="Select serialize type"
                  item-text="label"
                  item-value="value"
                  :rules="[
                            () => !!systemSerialize.type || 'Serialize type is required'
                          ]"
                  @change="verifyType(systemSerialize.type)"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="isShopFlag">
                <v-select
                  :items="shopList"
                  v-model="systemSerialize.shopId"
                  label="Select shop"
                  item-text="name"
                  item-value="id"
                  :rules="[
                            () => !!systemSerialize.shopId || 'Shop is required'
                          ]"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="isWarehouseFlag">
                <v-select
                  :items="warehouseList"
                  v-model="systemSerialize.warehouseId"
                  label="Select warehouse"
                  item-text="name"
                  item-value="id"
                  :rules="[
                            () => !!systemSerialize.warehouseId || 'Warehouse is required'
                          ]"
                ></v-select>
              </v-flex>
              <v-flex sm6 v-if="systemSerialize.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { systemSerializeService } from "../../services/system-serialize-service";
import { SystemSerialize } from "../../models/model";
import { shopService } from "../../services/shop-service";
import { warehouseService } from "../../services/warehouse-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";

export default {
  name: "SystemSerializeDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "System Serialize",
        disabled: false,
        to: "system-serializes"
      },
      {
        text: "System Serialize Detail",
        disabled: true
      }
    ],
    systemSerialize: new SystemSerialize(),
    oldSystemSerialize: new SystemSerialize(),
    statusFlag: true,
    isShopFlag: false,
    isWarehouseFlag: false,
    saveLoading: false,
    responseError: "",
    modelError: "",
    shopList: [],
    warehouseList: [],
    typeList: []
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new user
    } else {
      this.getSystemSerializeDetail(id);
    }
    this.getAllShop();
    this.getAllWarehouse();
    this.getAllSystemSerializeType();
  },
  methods: {
    verifyType(type) {
      if (type === "SALE" || type === "SHIFT_ASSIGN" || type === "WHOLE_SALE" || type === "DENOMINATION") {
        this.isShopFlag = true;
        this.isWarehouseFlag = false;
      } else {
        this.isShopFlag = false;
        this.isWarehouseFlag = true;
      }
    },
    getAllSystemSerializeType(){
      systemSerializeService
      .getAllSystemSerializeType()
      .then(res => {
          this.typeList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllWarehouse() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.systemSerialize.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let systemSerializeObj = {
          id: this.systemSerialize.id ? this.systemSerialize.id : "",
          prefix: this.systemSerialize.prefix,
          type: this.systemSerialize.type,
          shopId: this.systemSerialize.shopId,
          warehouseId: this.systemSerialize.warehouseId,
          status: this.systemSerialize.status
        };
        systemSerializeService
          .saveSystemSerialize(systemSerializeObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getSystemSerializeDetail(id) {
      systemSerializeService
        .getSystemSerializeDetail(id)
        .then(res => {
          this.systemSerialize = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.systemSerialize.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.systemSerialize.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldSystemSerialize = Object.assign({}, res.data);
          this.statusFlag =
            this.systemSerialize.status == "ACTIVE" ? true : false;
          this.isShopFlag = this.systemSerialize.shopId ? true : false;
          this.isWarehouseFlag = this.systemSerialize.warehouseId
            ? true
            : false;
        })
        .catch(err => {
          console.log(err);
        });
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.systemSerialize.id) {
        this.systemSerialize = new SystemSerialize();
        this.statusFlag = true;
        this.isShopFlag = false;
        this.isWarehouseFlag = false;
      } else {
        this.systemSerialize = Object.assign({}, this.oldSystemSerialize);
        this.statusFlag =
          this.systemSerialize.status == "ACTIVE" ? true : false;
        this.isShopFlag = this.systemSerialize.shopId ? true : false;
        this.isWarehouseFlag = this.systemSerialize.warehouseId ? true : false;
      }
    },
    goBack() {
      this.$router.push("/system-serializes");
    }
  }
};
</script>

